/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 26/09/2023
*/

import { Typography, Container, Box } from "@mui/material";

import "./LegalDocument.css";
import { textlanguages } from "../../../data/textOfThePage";
import { useLanguageContext } from "../../../context/languageContext";

export default function Terms() {
  const { languageSelected } = useLanguageContext();
  return (
    <Container>
      <Typography variant="h3" className="document-header">
        {textlanguages[languageSelected].legal.terms.title}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.terms.description[0]}{" "}
        <a
          style={{ color: "#005587" }}
          href={textlanguages[languageSelected].legal.terms.description[1]}
        >
          {textlanguages[languageSelected].legal.terms.description[1]}
        </a>{" "}
        {textlanguages[languageSelected].legal.terms.description[2]}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[0].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.terms.sections[0].paragraphs[0]}
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[0].paragraphs[1]}
      </Typography>
      <Box ml="30px" mt="20px">
        <LineNumber
          number="i."
          text={textlanguages[languageSelected].legal.terms.sections[0].list[0]}
        />
        <LineNumber
          number="ii."
          text={textlanguages[languageSelected].legal.terms.sections[0].list[1]}
        />
        <LineNumber
          number="iii."
          text={textlanguages[languageSelected].legal.terms.sections[0].list[2]}
        />
        <LineNumber
          number="iv."
          text={textlanguages[languageSelected].legal.terms.sections[0].list[3]}
        />
      </Box>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.terms.sections[0]
            .paragraphsAfterList[0]
        }
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.terms.sections[0]
            .paragraphsAfterList[1]
        }
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[1].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.terms.sections[1].paragraphs[0]}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[2].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.terms.sections[2].paragraphs[0]}
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[2].paragraphs[1]}{" "}
        <span style={{ color: "#005587" }}>
          {textlanguages[languageSelected].legal.terms.sections[2].email}
        </span>
        .
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[2].paragraphs[2]}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[3].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.terms.sections[3].paragraphs[0]}
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[3].paragraphs[1]}
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[3].paragraphs[2]}
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[3].paragraphs[3]}
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[3].paragraphs[4]}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[4].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.terms.sections[4].paragraphs[0]}{" "}
        <span style={{ textDecoration: "underline" }}>
          {
            textlanguages[languageSelected].legal.terms.sections[4]
              .paragraphs[1]
          }
        </span>{" "}
        {textlanguages[languageSelected].legal.terms.sections[4].paragraphs[2]}{" "}
        <span style={{ textDecoration: "underline" }}>
          {
            textlanguages[languageSelected].legal.terms.sections[4]
              .paragraphs[3]
          }
        </span>{" "}
        {textlanguages[languageSelected].legal.terms.sections[4].paragraphs[4]}
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[4].paragraphs[5]}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[5].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.terms.sections[5].paragraphs[0]}
      </Typography>
      <Box ml="30px" mt="20px">
        <LineNumber
          number="i."
          text={textlanguages[languageSelected].legal.terms.sections[5].list[0]}
        />
        <LineNumber
          number="ii."
          text={textlanguages[languageSelected].legal.terms.sections[5].list[1]}
        />
        <LineNumber
          number="iii."
          text={textlanguages[languageSelected].legal.terms.sections[5].list[2]}
        />
      </Box>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.terms.sections[5]
            .paragraphsAfterList[0]
        }
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[6].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.terms.sections[6].paragraphs[0]}
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[6].paragraphs[1]}
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.terms.sections[6].paragraphs[2]}
      </Typography>
      <Typography
        variant="h6"
        className="document-content"
        mt="20px"
        style={{ fontWeight: "bold", textAlign: "end" }}
      >
        {textlanguages[languageSelected].legal.terms.sections[6].lastUpdate}
      </Typography>
    </Container>
  );
}

const LineNumber = ({ number, text }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          alignItems: "start",
          width: "40px",
          minWidth: "40px",
        }}
      >
        {number}
      </Typography>
      <Typography variant="h6" className="document-content">
        {text}
      </Typography>
    </Box>
  );
};
